// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2rVSW","legacyBtn":"MutateMid_legacyBtn__2oFN_"};